"use client";

import type { ReactNode } from "react";

import { Button } from "@homeinstead/ui/components/Button";
import { ChevronRight } from "lucide-react";
import { useState } from "react";

export function ShowMoreJobs({ children }: { children: ReactNode }) {
  const [expanded, setExpanded] = useState(false);

  if (expanded) {
    return children;
  }

  return (
    <div className="pt-8 md:pt-14">
      <Button
        className="gap-0.5 font-bold text-new-beginnings-base underline hover:no-underline"
        onClick={() => setExpanded(true)}
        size={null}
        variant="plain"
      >
        View all available jobs
        <ChevronRight aria-hidden className="size-4" />
      </Button>
    </div>
  );
}
